(ns storrito.ui.core)

(def h1
  ["font-extrabold"
   "text-3xl"
   "text-gray-900"])

(def h2
  ["font-extrabold"
   "text-2xl"
   "text-gray-900"])

(def h3
  ["font-extrabold"
   "text-xl"
   "text-gray-900"])

(def a
  ["font-medium"
   "underline"
   "text-gray-600"
   "hover:text-gray-900"])

(def a-bold
  ["font-semibold"
   "underline"
   "text-gray-900"
   "hover:text-gray-600"])

(def a-sm
  ["text-xs"
   "underline"
   "text-gray-600"
   "hover:text-gray-800"])

(def box
  ["shadow"
   "rounded-lg"
   "border"
   "overflow-auto"])

(def a-discrete
  ["underline"
   "text-gray-800"
   "hover:text-gray-600"])

(def button-md
  ["px-4"
   "py-2"
   "text-md"])

(def button-xs
  ["px-2.5" "py-1.5" "text-xs"])

(def button-sm
  ["px-2"
   "py-1"
   "text-sm"])

(def button-default
  ["inline-flex"
   "items-center"
   "border"
   "rounded"
   "rounded-md"
   "shadow-sm"
   "focus:outline-none"
   "focus:ring-1"
   "font-medium"
   "justify-center"
   "align-center"
   "cursor-pointer"])

(def button-round
  ["border"
   "rounded-full"
   "shadow-sm"
   "focus:outline-none"
   "focus:ring-1"
   "font-medium"
   "cursor-pointer"])

(def button-secondary-xs
  (concat
    button-xs
    button-default
    ["border-gray-300"
     "hover:border-gray-400"
     "text-gray-800"
     "bg-white"
     "hover:bg-gray-50"
     "focus:ring-offset-gray-800"
     "focus:ring-secondary-800"]))

(def button-secondary
  (concat
    button-md
    button-default
    ["border-gray-300"
     "hover:border-gray-400"
     "text-gray-800"
     "bg-white"
     "hover:bg-gray-50"
     "focus:ring-offset-gray-800"
     "focus:ring-secondary-800"]))

(def button-primary
  (concat
    button-md
    button-default
    ["text-white"
     "bg-secondary-500"
     "hover:bg-secondary-300"
     "focus:ring-secondary-500"
     "disabled:cursor-not-allowed"
     "disabled:bg-secondary-100"]))

(def button-sm-cta-round
  (concat
    button-sm
    button-round
    ["text-white"
     "hover:text-white"
     "bg-indigo-500"
     "hover:bg-indigo-600"
     "focus:ring-indigo-500"
     "disabled:cursor-not-allowed"
     "disabled:bg-indigo-100"]))

(def a-indigo
  ["font-semibold"
   "text-indigo-600"
   "hover:text-indigo-500"])

(def a-indigo-bold
  ["font-bold"
   "text-md"
   "underline"
   "text-indigo-600"
   "hover:text-indigo-500"])

(def input-label
  ["font-medium" "mb-2"])

(def modal-form
  ["m-0"
   "flex"
   "flex-col"
   "gap-4"])

(def container
  ["container"
   "mx-auto"
   "max-w-5xl"
   "p-6"
   "m-4"])
